import it from '../../i18n/it.json';
import en from '../../i18n/en.json';
import fr from '../../i18n/fr.json';
import es from '../../i18n/es.json';

import 'moment/locale/it';
import 'moment/locale/es';
import 'moment/locale/en-gb';
import 'moment/locale/fr';
import moment from 'moment';

const mapLanguage = {
    it, en, fr, es
}

export const supportedLangs = ['it', 'en', 'fr', 'es'];

export const SETTINGS_SET_TRANSLATIONS = 'SETTINGS_SET_TRANSLATIONS';
export const settingsSetTranslations = (translations, language) => ({ type: SETTINGS_SET_TRANSLATIONS, translations, language });

export const SETTINGS_SET_LANGUAGE = 'SETTINGS_SET_LANGUAGE';
export const settingsSetLanguage = () => async dispatch => {
    const browserLang = supportedLangs.find(lang => navigator.language.indexOf(lang) !== -1) || 'en';
    const translations = mapLanguage[browserLang];

    // try {
    //     switch (browserLang) {
    //         case 'it': await import('moment/locale/it'); break;
    //         case 'es': await import('moment/locale/es'); break;
    //         case 'fr': await import('moment/locale/fr'); break;
    //         default: await import('moment/locale/en-gb');
    //     }
    // } catch (error) {
    //     console.log('Error importing locale ', error);
    // }

    switch (browserLang) {
        case 'it': moment.locale('it'); break;
        case 'es': moment.locale('es'); break;
        case 'fr': moment.locale('fr'); break;
        case 'en':
        default: moment.locale('en-gb');
    }

    dispatch(settingsSetTranslations(translations, browserLang));
}


// WEBPACK FOOTER //
// ./src/store/actions/settings.js